import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslocoDirective} from "@jsverse/transloco";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgSelectModule} from "@ng-select/ng-select";
import {FlatpickrModule} from "angularx-flatpickr";
import {CoreCommonModule} from "../../../../@core/common.module";
import {SharedModule} from "../shared/shared.module";
import {AdvancedFiltersComponent} from "./advanced-filters.component";
import {AppliedAdvancedFilterComponent} from "./components/applied-advanced-filter/applied-advanced-filter.component";
import {CheckboxFilterComponent} from "./components/filter-implementaitons/checkbox-filter/checkbox-filter.component";
import {DatepickerFilterComponent} from "./components/filter-implementaitons/datepicker-filter/datepicker-filter.component";
import {DroplistFilterComponent} from "./components/filter-implementaitons/droplist-filter/droplist-filter.component";
import {PredicateFilterComponent} from "./components/predicate-filter/predicate-filter.component";
import {TextFilterComponent} from "./components/filter-implementaitons/text-filter/text-filter.component";
import { OperatorSelectorComponent } from './components/operator-selector/operator-selector.component';
import { NumberFilterComponent } from './components/filter-implementaitons/number-filter/number-filter.component';
import { AppliedFilterValuePreviewComponent } from './components/applied-filter-value-preview/applied-filter-value-preview.component';
import { FilterGroupNamePipe } from './pipes/filter-group-name.pipe';
import { NgScrollbarModule } from 'ngx-scrollbar';




@NgModule({
  declarations: [
      AppliedAdvancedFilterComponent,
      CheckboxFilterComponent,
      DatepickerFilterComponent,
      DroplistFilterComponent,
      PredicateFilterComponent,
      TextFilterComponent,
      AdvancedFiltersComponent,
      OperatorSelectorComponent,
      NumberFilterComponent,
      AppliedFilterValuePreviewComponent,
      FilterGroupNamePipe
  ],
    imports: [
        CommonModule,
        NgbModule,
        FlatpickrModule,
        CoreCommonModule,
        SharedModule,
        NgSelectModule,
        NgScrollbarModule,
        TranslocoDirective,
    ],
    exports:[
        AppliedAdvancedFilterComponent,
        AdvancedFiltersComponent
    ]
})
export class AdvancedFiltersModule { }
